<template lang="pug">
.leftNav
  el-input(v-model="filterTextSys", size="small", placeholder="输入关键字进行过滤", clearable)
  .allCheckStyle
    el-checkbox(v-model="checked",@change="allCheck") {{ checkTitle }}
  el-tree.treeList.filter-tree(
    ref="roletree",
    node-key="nodeId",
    :data="specData",
    :props="defaultRoleProps",
    :filter-node-method="filterNode",
    show-checkbox,
    @check="checkNodeChange",
    v-slot="{ node, data }"
  )
    node-icon(:node="node", type="SpecRole") {{ data.roleName }}
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import NodeIcon from "./NodeIcon.vue";

export default {
  components: { NodeIcon },
  props: {
    // 选中的人员组件
    userList: { type: Array, default: () => [] }
  },
  data() {
    return {
      specData: [], // 专业角色列表
      filterTextSys: "",
      defaultRoleProps: {
        children: "children",
        label: "roleName"
      },
      nowSelect: [],
      childrenData: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    defaultCheckedKeys() {
      return this.nowSelect?.map(({ nodeId }) => nodeId) || [];
    },
    checked: {
      get() {
        return this.childrenData.length > 0 && (this.childrenData.length === this.nowSelect.length);
      },
      set(val) {}
    },
    checkTitle() {
      return this.checked ? '反选' : '全选';
    }
  },
  watch: {
    filterTextSys(val) {
      this.$refs.roletree.filter(val);
    },
    userList: {
      immediate: true,
      async handler(val) {
        this.nowSelect = val;
        this.$refs.roletree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    }
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    // 获取专业角色列表
    async getRoleList() {
      this.childrenData = [];
      const res = await flowService.querySpecRoleTree(this.enterpriseId);
      const oldArray = res.data || [];
      const each = list => {
        for (const item of list) {
          if (item.nodeType === 'role') {
            this.childrenData.push(item);
          }
          item.nodeId = item.roleId;
          if (item.children && item.children.length > 0) each(item.children);
          else delete item.children;
        }
      };
      each(oldArray);
      this.specData = oldArray;
      if (this.nowSelect && this.nowSelect.length > 0) {
        await this.$nextTick();
        this.$refs.roletree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    },
    // 系统角色树形结构选择器
    checkNodeChange(data, currentChecked) {
      this.nowSelect = this.$refs.roletree.getCheckedNodes().filter((item) => item.nodeType === "role");
      this.emitList();
    },
    // 给父级抛出选中的人员
    emitList() {
      const list = this.nowSelect.map((e) => {
        return {
          ...e,
          id: e.roleId,
          userId: e.roleId,
          name: e.roleName,
          selectName: e.roleName,
          type: 2
        };
      });
      this.$emit("updateRight", "SpecRole", list);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },
    allCheck() {
      if (!this.checked) {
        const ids = this.childrenData.map(i => i.roleId);
        this.nowSelect = this.childrenData;
        this.$refs.roletree.setCheckedKeys(ids);
      } else {
        this.nowSelect = [];
        this.$refs.roletree.setCheckedKeys([]);
      }
      this.emitList();
    }
  }
};
</script>

<style lang="scss" scoped>
.allCheckStyle{
  text-align: end;
  height: 25px;
  line-height: 25px;
  padding: 0 20px;
}
</style>
